(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article-seissense"]) return;
  try {
    
  (function () {
    var prose = document.querySelector('[data-ss-prose]');
    var toc = document.querySelector('[data-ss-toc]');
    if (!prose || !toc) return;
    var heads = prose.querySelectorAll('h2');
    if (heads.length < 2) return;
    var list = toc.querySelector('.ss-toc__list');
    heads.forEach(function (h, i) {
      if (!h.id) h.id = 'section-' + (i + 1);
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      list.appendChild(li);
    });
    toc.hidden = false;
    if (!('IntersectionObserver' in window)) return;
    var links = list.querySelectorAll('a');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        links.forEach(function (l) {
          l.classList.toggle('is-active', l.getAttribute('href') === '#' + e.target.id);
        });
      });
    }, { rootMargin: '-20% 0px -70% 0px' });
    heads.forEach(function (h) { io.observe(h); });
  })();

  } catch(e) { console.error(e); }
})();
})();
